import { Box, Typography, Button, CircularProgress, List, ListItem, ListItemIcon, ListItemText } from '@mui/material'
import { BooleanInput, email, Form, LoginFormClasses, required, TextInput, useNotify, useSafeSetState, useTranslate } from 'react-admin'
import { Circle } from '@mui/icons-material'
import { apiService } from '../apiService'
import CustomLink from '../customStyles/CustomLink'
import { useState } from 'react'
import qualityIcons from './../resources/qualityIcons.png'
import hook from './../resources/freeBILLHaken_logo.png'
import lady from './../resources/header-lady.png'

export const Register = () => {
  
  const [loading, setLoading] = useSafeSetState(false)
  const [sent, setSent] = useSafeSetState<boolean>(false)
  const [acceptTerms, setAcceptTerms] = useState<boolean>(false)
  const notify = useNotify()
  const translate = useTranslate()

  const submit = async(values: any) => {
    if(!acceptTerms) {
      notify(translate("resources.authentication.register.noTerms"), {type: "error"})
      return
    }
    setLoading(true);
    try {
      var location = window.location
      var urlIncludesFbl = location.href.includes("/fbl/")
      var backlinkUrl = `${location.origin}${urlIncludesFbl ? "/fbl" : ""}/#/login?page=setupUserLogin`
      await apiService.UsersApi.register({registerCommand: {email: values.email, backlinkUrl: backlinkUrl, isNewsletterAccepted: values.mailings}})
      notify(translate("resources.authentication.register.feedback"), {type:"success", autoHideDuration: 7000})
      setSent(true)
      setLoading(false);
    } catch (error:any) {
      setLoading(false);
      notify(
        typeof error === 'string'
            ? error
            : typeof error === 'undefined' || !error.message
            ? 'ra.auth.sign_in_error'
            : error.message,
        {
            type: 'error',
            messageArgs: {
                _:
                    typeof error === 'string'
                        ? error
                        : error && error.message
                        ? error.message
                        : undefined,
            },
        }
      )
    }
  }

  return (
    <Box>
      <Box display={"flex"} px={8} py={5} position={"relative"} width={"100%"} sx={{background: "linear-gradient(135deg, #003b5b 0%, #005478 100%)"}} >
        <Box display={{xs: "none", md: "block"}} position={"absolute"} bottom={-8} left={0}>
          <Box 
            component={"img"}
            sx={{width: 250}}
            src={lady}
          />
        </Box>
        <Box>
          <Typography display={{xs:"none", sm:"block"}} variant='h3' color={"white"}>Herzlich Willkommen bei freeBill!</Typography>
          <Box pl={{xs:0, md:28}} pt={5} >
            <Typography variant='h5' color={"white"}>Einfaches Rechnungsprogramm für:</Typography>
            <List>
              <ListItem alignItems='flex-start'>
                <Box display={"flex"} alignItems={"center"}>
                  <ListItemIcon sx={{minWidth: 50}}>
                    <Box 
                      component={"img"}
                      sx={{width: 30}}
                      src={hook}
                    />
                  </ListItemIcon>
                  <ListItemText sx={{pt:1}}><Typography color='white' variant='h5'><strong>E-Rechnungen</strong></Typography></ListItemText>
                </Box> 
              </ListItem>
              <ListItem alignItems='flex-start'>
                <Box display={"flex"} alignItems={"center"}>
                  <ListItemIcon sx={{minWidth: 50}}>
                    <Box 
                      component={"img"}
                      sx={{width: 30}}
                      src={hook}
                    />
                  </ListItemIcon>
                  <ListItemText sx={{pt:1}}><Typography color='white' variant='h5'><strong>Mahnungen</strong></Typography></ListItemText>
                </Box> 
              </ListItem>
              <ListItem alignItems='flex-start'>
                <Box display={"flex"} alignItems={"center"}>
                  <ListItemIcon sx={{minWidth: 50}}>
                    <Box 
                      component={"img"}
                      sx={{width: 30}}
                      src={hook}
                    />
                  </ListItemIcon>
                  <ListItemText sx={{pt:1}}><Typography color='white' variant='h5'><strong>Buchhaltung & Co.</strong></Typography></ListItemText>
                </Box> 
              </ListItem>
            </List>
          </Box>
        </Box>
        <Box display={{xs: "none", lg: "block"}} sx={{backgroundColor: "#f3f3fa", borderTopLeftRadius: 10, borderBottomLeftRadius: 10}} px={1} position={"absolute"} bottom={30} right={0} >
          <Box 
            component={"img"}
            sx={{width: 600}}
            src={qualityIcons}
          />
        </Box>
      </Box>
      <Box px={10} pt={5} pb={10} display={"flex"} width={"100%"} sx={{backgroundColor: "#f3f3fa"}} justifyContent={"space-between"}>
        <Box width={{xs: "100%", md: "45%"}}>
          <Box display={"flex"}>
            <Typography variant='h6'>{translate("resources.authentication.register.description")}</Typography>
          </Box>
          <Box py={2}>
            <Form
              onSubmit={submit}
              mode="onChange"
              noValidate
            >
              <TextInput 
                autoFocus
                source="email"
                label="Email"
                autoComplete="email"
                validate={[required(), email()]}
                fullWidth
              />
              <BooleanInput 
                source='terms'
                value={acceptTerms}
                onChange={(e) => setAcceptTerms(e.target.checked)}
                label={
                  <Typography>
                    Ich habe die <CustomLink href='https://www.freefibu.de/agb/' text={"allgemeinen Geschäftsbestimmungen"} />  sowie die <CustomLink href='https://www.freefibu.de/datenschutz/' text={"Datenschutzhinweise"} /> gelesen und erkläre mich mit den Inhalten einverstanden.
                  </Typography>
                }
              />
              <BooleanInput 
                source='mailings' 
                label={
                  <Typography>
                    {translate("resources.authentication.register.mailings")}
                  </Typography>
                }
              />
              <Button
                  variant={"contained"}
                  type="submit"
                  disabled={loading || sent}
                  fullWidth
                  className={LoginFormClasses.button}
                  size='small'
              >
                  {loading ? (
                      <CircularProgress
                          className={LoginFormClasses.icon}
                          size={19}
                          thickness={3}
                      />
                  ) : (
                    translate("resources.authentication.register.action")
                  )}
              </Button>
            </Form>
          </Box>
        </Box>  
        <Box width={"45%"} display={{xs:"none", sm:"block"}} >
          <Box>
            <Typography variant='h6'>{translate("resources.authentication.register.description1")}</Typography>
            <List>
              <ListItem alignItems='flex-start'>
                <ListItemIcon sx={{minWidth: 25}}><Circle sx={{fontSize:15}} /></ListItemIcon>
                <ListItemText><Typography><strong>Einfache Bedienung:</strong> Unsere intuitive Benutzeroberfläche macht die Rechnungserstellung zum Kinderspiel.</Typography></ListItemText>
              </ListItem>
              <ListItem alignItems='flex-start'>
                <ListItemIcon sx={{minWidth: 25}}><Circle sx={{fontSize:15}} /></ListItemIcon>
                <ListItemText><Typography><strong>Kostenlose Grundversion:</strong> Im Grundpaket können bis zu 3 Rechnungen pro Monat kostenlos erstellt werden.</Typography></ListItemText>
              </ListItem>
              <ListItem alignItems='flex-start'>
                <ListItemIcon sx={{minWidth: 25}}><Circle sx={{fontSize:15}} /></ListItemIcon>
                <ListItemText><Typography><strong>Maßgeschneiderte Pakete:</strong> Bei Bedarf kannst du die für dich passenden Features über ein preiswertes Abo freischalten.</Typography></ListItemText>
              </ListItem>
              <ListItem alignItems='flex-start'>
                <ListItemIcon sx={{minWidth: 25}}><Circle sx={{fontSize:15}} /></ListItemIcon>
                <ListItemText><Typography><strong>Zuverlässiger Support:</strong> Unser freundliches und engagiertes Support-Team steht dir zur Seite, um Fragen zu beantworten und dich zu unterstützen.</Typography></ListItemText>
              </ListItem>
            </List>
          </Box>
        </Box>
      </Box>
    </Box>

)
}
